// removed by extract-text-webpack-plugin
module.exports = {"chip":"theme__chip___1JkDk","avatar":"theme__avatar___2s8s3","deletable":"theme__deletable___3JR8A","delete":"theme__delete___1r4MM","deleteIcon":"theme__deleteIcon___1qgur","deleteX":"theme__deleteX___3T_yL"};


//////////////////
// WEBPACK FOOTER
// ./~/@luminopia/react-toolbox/lib/chip/theme.css
// module id = 1191
// module chunks = 0